import { CartStatusesEnum, IServiceIconsColors, IThirdPartyStyles, ServiceCategoryIdEnum } from "@monorepo/types";

import {
  DirectPaymentIcon,
  EducationIcon,
  ElectricityIcon,
  FinancialIcon,
  FishingIcon,
  GarbageIcon,
  GasIcon,
  HeatIcon,
  HouseCareIcon,
  InvoicesIcon,
  OtherIcon,
  SecurityIcon,
  TelecommunicationIcon,
  WaterIcon,
} from "./CustomIcons/CustomIcons";

const thirdPartyAttached = document?.getElementById("perlasgo-third-party-attached");
const isThirdParty = !!thirdPartyAttached?.getAttribute("data-hostname")?.length;
const iconsColors = thirdPartyAttached?.getAttribute("data-service-icons-colors");
let serviceIconsColorsThirdParty: IServiceIconsColors | undefined;
if (isThirdParty && !!iconsColors && typeof iconsColors === "string" && typeof JSON.parse(iconsColors) === "object") {
  serviceIconsColorsThirdParty = (JSON.parse(iconsColors) as IThirdPartyStyles).serviceIconsColors;
}
export enum ServiceIconsSizeEnum {
  SMALL = "small",
  LARGE = "large",
}

export const serviceIconsColors: IServiceIconsColors = {
  electricity: { color: "#FFEA52", stroke: "#003939" },
  gas: { color: "#FFEFAB", stroke: "#003939" },
  water: { color: "#32B88E", stroke: "#003939" },
  heat: { color: "#77F89D", stroke: "#003939" },
  houseCare: { color: "#EA84FE", stroke: "#003939" },
  telecommunications: { color: "#BAF4CD", stroke: "#003939" },
  financialServices: { color: "#B3BAF5", stroke: "#003939" },
  security: { color: "#7780EC", stroke: "#003939" },
  education: { color: "#97B7AB", stroke: "#003939" },
  directPayment: { color: "#B9E2D4", stroke: "#003939" },
  fishing: { color: "#ACD8FF", stroke: "#003939" },
  invoices: { color: "#73C3FF", stroke: "#003939" },
  other: { color: "#FFC140", stroke: "#003939" },
  garbage: { color: "#F9D4FF", stroke: "#003939" },
  ...(!!serviceIconsColorsThirdParty &&
    typeof serviceIconsColorsThirdParty === "object" &&
    serviceIconsColorsThirdParty),
};

const getIconComponent = ({
  serviceId,
  size = ServiceIconsSizeEnum.LARGE,
  active = true,
  delayed = false,
  statusId,
}: IProps) => {
  const props = {
    size,
    active,
    delayed,
    statusId,
  };
  switch (true) {
    case serviceId === ServiceCategoryIdEnum.ELECTRICITY: {
      return <ElectricityIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.GAS: {
      return <GasIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.WATER: {
      return <WaterIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.HEAT: {
      return <HeatIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.HOUSE_CARE: {
      return <HouseCareIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.TELECOMMUNICATIONS: {
      return <TelecommunicationIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.FINANCIAL_SERVICES: {
      return <FinancialIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.SECURITY: {
      return <SecurityIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.EDUCATION: {
      return <EducationIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.DIRECT_PAYMENT: {
      return <DirectPaymentIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.FISHING: {
      return <FishingIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.INVOICES: {
      return <InvoicesIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.OTHER: {
      return <OtherIcon {...props} />;
    }
    case serviceId === ServiceCategoryIdEnum.GARBAGE: {
      return <GarbageIcon {...props} />;
    }
    default:
      return <TelecommunicationIcon {...props} />;
  }
};

interface IProps {
  serviceId: ServiceCategoryIdEnum;
  size?: ServiceIconsSizeEnum;
  active?: boolean;
  delayed?: boolean;
  statusId?: CartStatusesEnum;
}

export const ServiceIcons = ({
  serviceId,
  size = ServiceIconsSizeEnum.LARGE,
  active = true,
  delayed = false,
  statusId,
}: IProps) => getIconComponent({ serviceId, size, active, delayed, statusId });
